var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InsertLinkOutlined } from "@mui/icons-material";
import { Avatar, Divider, LinearProgress, MenuItem, Typography, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ValidationTypes } from "../../../builderPackage/components/regex/validations";
import { MuiStack } from "../../../components";
import { EParentModuleName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { resetState, setReducerState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { black, faintGray, gray, lightGray } from "../../../theme/palette";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate, isLoadingState } from "../../../utils/utils";
import { getServiceAdvisorListAPICall } from "../../spareIssue/services/apiCalls";
import { EditIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { AddressMapSVG, MailOutlineSVG, VerifiedSVG } from "../assets/assets";
import NoDocumentFound from "../components/NoDocumentFound";
import ProprietaryWarrantyDetails from "../components/warrantyDetails";
import { getFilterTypeList, getSearchByValueAPICall, proprietaryWarrantyCreateAPICall, proprietaryWarrantyGetAPICall } from "../services/apiCall";
import { ProprietaryWarrantyApiKeys, ProprietaryWarrantyKeys, ProprietaryWarrantyMandatoryFields, ProprietaryWarrantyResetKeys } from "../services/entity";
import EditCustomerInfo from "../../../components/templates/editCustomerInfo";
import WarrantyTabMobView from "../components/warrantyTabMobView";
export var CreatePropritaryWarrantyIndex = function (props) {
    var _crud$ProprietaryWarr, _crud$ProprietaryWarr2, _crud$ProprietaryWarr3, _crud$ProprietaryWarr4, _crud$ProprietaryWarr5, _crud$ProprietaryWarr6, _getLocalStorageItem, _ref, _data$Customer, _crud$ProprietaryWarr7, _getLocalStorageItem2, _customerData$GivenNa, _customerData$FamilyN, _customerData$Country, _customerData$MobileN, _customerData$Alterna, _ref2, _customerData$Email, _getData$PersonContac, _customerData$Address, _customerData$Address2, _customerData$Address3, _customerData$Address4, _customerData$Address5, _customerData$Address6, _customerData$Address7, _customerData$Address8, _customerData$Address9, _getData$Code, _crud$ProprietaryWarr8, _crud$ProprietaryWarr9, _crud$ProprietaryWarr10;
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState(false), editCustomer = _a[0], setEditCustomer = _a[1];
    var crud = useAppSelector(function (state) { return state.crud; });
    var data = (_crud$ProprietaryWarr = crud === null || crud === void 0 || (_crud$ProprietaryWarr2 = crud[ProprietaryWarrantyKeys.GetSearchByTypeResults]) === null || _crud$ProprietaryWarr2 === void 0 ? void 0 : _crud$ProprietaryWarr2.data) !== null && _crud$ProprietaryWarr !== void 0 ? _crud$ProprietaryWarr : null;
    var getData = (_crud$ProprietaryWarr3 = crud === null || crud === void 0 || (_crud$ProprietaryWarr4 = crud[ProprietaryWarrantyKeys.Get]) === null || _crud$ProprietaryWarr4 === void 0 ? void 0 : _crud$ProprietaryWarr4.data) !== null && _crud$ProprietaryWarr3 !== void 0 ? _crud$ProprietaryWarr3 : [];
    var installbaseData = data && data !== null && data !== void 0 && data.InstallBase ? data === null || data === void 0 ? void 0 : data.InstallBase : (_crud$ProprietaryWarr5 = crud[ProprietaryWarrantyKeys.GetInstallBaseData]) !== null && _crud$ProprietaryWarr5 !== void 0 && _crud$ProprietaryWarr5.data ? (_crud$ProprietaryWarr6 = crud[ProprietaryWarrantyKeys.GetInstallBaseData]) === null || _crud$ProprietaryWarr6 === void 0 ? void 0 : _crud$ProprietaryWarr6.data : [];
    var organizationId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var customerData = (_ref = (_data$Customer = data === null || data === void 0 ? void 0 : data.Customer) !== null && _data$Customer !== void 0 ? _data$Customer : crud === null || crud === void 0 || (_crud$ProprietaryWarr7 = crud[ProprietaryWarrantyKeys.GetCustomerDetails]) === null || _crud$ProprietaryWarr7 === void 0 ? void 0 : _crud$ProprietaryWarr7.data) !== null && _ref !== void 0 ? _ref : {};
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var getServiceAdvisorByOrganizationId = function (params) { return getServiceAdvisorListAPICall(_objectSpread(_objectSpread({}, params.request), {}, {
        request: {
            BranchId: organizationId
        }
    })); };
    var id = useParams().id;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    useEffect(function () {
        getFilterTypeList({});
    }, [mode === 'add']);
    var request = {
        OrganizationId: organizationId,
        ParentOrganizationId: parentOrganizationId
    };
    var General = [{
            type: FormItemTypes.CardComponent,
            name: 'CustomerDetails',
            columnSize: 12,
            variant: 'outlined',
            containerProps: {
                display: mode === 'edit' || data ? 'flex' : 'none',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                flex: 1,
                gap: '20px',
                width: '100%'
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'CustomerInfo',
                    alignContent: 'flex-start',
                    columnSize: 6,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Customer details',
                            variant: 'h3',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: 'CustomerInfo',
                            variant: 'outlined',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: 'CustomerInfo',
                                    containerProps: {
                                        flexDirection: 'column'
                                    },
                                    columnSize: 12,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: 'Avatar',
                                            columnSize: 0,
                                            element: function (props) { /*#__PURE__*/ return React.createElement(Avatar, null); }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'CustomerName',
                                            columnSize: true,
                                            label: customerData !== null && customerData !== void 0 && customerData.GivenName || customerData !== null && customerData !== void 0 && customerData.FamilyName ? "".concat((_customerData$GivenNa = customerData === null || customerData === void 0 ? void 0 : customerData.GivenName) !== null && _customerData$GivenNa !== void 0 ? _customerData$GivenNa : '', " ").concat((_customerData$FamilyN = customerData === null || customerData === void 0 ? void 0 : customerData.FamilyName) !== null && _customerData$FamilyN !== void 0 ? _customerData$FamilyN : ' ').trim() : "-",
                                            children: /*#__PURE__*/ React.createElement(MuiStack, {
                                                flexDirection: 'row',
                                                spacing: 1
                                            }, /*#__PURE__*/ React.createElement(MuiStack, {
                                                spacing: 0.2,
                                                borderRight: "1px solid ".concat(faintGray),
                                                pr: 2
                                            }, /*#__PURE__*/ React.createElement(Typography, null, "".concat((_customerData$Country = customerData === null || customerData === void 0 ? void 0 : customerData.CountryCode) !== null && _customerData$Country !== void 0 ? _customerData$Country : '').concat((_customerData$MobileN = customerData === null || customerData === void 0 ? void 0 : customerData.MobileNumber) !== null && _customerData$MobileN !== void 0 ? _customerData$MobileN : '-')), (customerData === null || customerData === void 0 ? void 0 : customerData.IsMobileVerified) && /*#__PURE__*/ React.createElement(VerifiedSVG, null)), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, null, "".concat((_customerData$Alterna = customerData === null || customerData === void 0 ? void 0 : customerData.AlternateNumber) !== null && _customerData$Alterna !== void 0 ? _customerData$Alterna : '-')), (customerData === null || customerData === void 0 ? void 0 : customerData.IsAlternateNumberVerified) && /*#__PURE__*/ React.createElement(VerifiedSVG, null))),
                                            labelTypographyProps: {
                                                variant: 'h3',
                                                whiteSpace: 'nowrap'
                                            }
                                        }, {
                                            type: FormItemTypes.IconButton,
                                            name: 'Edit',
                                            children: /*#__PURE__*/ React.createElement(EditIconSVG, {
                                                sx: {
                                                    color: gray
                                                }
                                            }),
                                            columnSize: 0,
                                            onClick: function () {
                                                setEditCustomer(true);
                                            }
                                        }],
                                    p: 1,
                                    borderBottom: "1px solid ".concat(faintGray)
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: 'CustomerMailInfo',
                                    columnSize: 12,
                                    alignItems: 'flex-start',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'email',
                                            columnSize: 12,
                                            children: /*#__PURE__*/ React.createElement(MuiStack, {
                                                flexDirection: 'row',
                                                spacing: 1,
                                                alignContent: 'center',
                                                alignItems: 'center'
                                            }, /*#__PURE__*/ React.createElement(MailOutlineSVG, {
                                                sx: {
                                                    width: '14px',
                                                    height: '14px'
                                                }
                                            }), /*#__PURE__*/ React.createElement(Typography, null, (_ref2 = (_customerData$Email = customerData === null || customerData === void 0 ? void 0 : customerData.Email) !== null && _customerData$Email !== void 0 ? _customerData$Email : getData === null || getData === void 0 || (_getData$PersonContac = getData.PersonContactPoint) === null || _getData$PersonContac === void 0 ? void 0 : _getData$PersonContac.Email) !== null && _ref2 !== void 0 ? _ref2 : ''))
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'address',
                                            columnSize: 12,
                                            children: /*#__PURE__*/ React.createElement(MuiStack, {
                                                flexDirection: 'row',
                                                spacing: 1,
                                                alignContent: 'center',
                                                alignItems: 'center'
                                            }, /*#__PURE__*/ React.createElement(AddressMapSVG, null), /*#__PURE__*/ React.createElement(Typography, null, customerData !== null && customerData !== void 0 && customerData.Address && (_customerData$Address = customerData.Address[0]) !== null && _customerData$Address !== void 0 && _customerData$Address.Address1 ? "".concat((_customerData$Address2 = (_customerData$Address3 = customerData.Address[0]) === null || _customerData$Address3 === void 0 ? void 0 : _customerData$Address3.Address1) !== null && _customerData$Address2 !== void 0 ? _customerData$Address2 : ' ', "\n                                                     ").concat((_customerData$Address4 = (_customerData$Address5 = customerData.Address[0]) === null || _customerData$Address5 === void 0 ? void 0 : _customerData$Address5.Address2) !== null && _customerData$Address4 !== void 0 ? _customerData$Address4 : ' ', ",\n                                                      ").concat((_customerData$Address6 = (_customerData$Address7 = customerData.Address[0]) === null || _customerData$Address7 === void 0 ? void 0 : _customerData$Address7.Address3) !== null && _customerData$Address6 !== void 0 ? _customerData$Address6 : ' ', ",\n                                                       ").concat((_customerData$Address8 = (_customerData$Address9 = customerData.Address[0]) === null || _customerData$Address9 === void 0 ? void 0 : _customerData$Address9.Address4) !== null && _customerData$Address8 !== void 0 ? _customerData$Address8 : ' ') : '-'))
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'Vehicle Changes',
                    columnSize: 6,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    spacing: 2.2,
                    alignContent: 'flex-start',
                    elements: __spreadArray([{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Select vehicle',
                            variant: 'h3',
                            columnSize: 0
                        }], (installbaseData === null || installbaseData === void 0 ? void 0 : installbaseData.map(function (item, index) { return ({
                        type: FormItemTypes.CardComponent,
                        name: 'Customer',
                        variant: 'outlined',
                        sx: {
                            m: 0,
                            pl: 1,
                            borderRadius: '8px'
                        },
                        columnSize: 12,
                        setFieldProps: function (formValues, currValue) {
                            var filter = installbaseData === null || installbaseData === void 0 ? void 0 : installbaseData.filter(function (item, index) { return formValues[item === null || item === void 0 ? void 0 : item.RegistrationNo]; });
                            var display = function () {
                                if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                                    if (formValues[item === null || item === void 0 ? void 0 : item.RegistrationNo]) {
                                        return 'inline-block';
                                    }
                                    else {
                                        return 'none';
                                    }
                                }
                                else {
                                    return 'inline-block';
                                }
                            };
                            return {
                                type: this.type,
                                containerProps: {
                                    display: display
                                }
                            };
                        },
                        elements: [{
                                type: FormItemTypes.CheckBox,
                                name: item === null || item === void 0 ? void 0 : item.RegistrationNo,
                                columnSize: 0,
                                setFieldProps: function (formValues, currValue) {
                                    var _a;
                                    formValues = _objectSpread(_objectSpread({}, formValues), {}, (_a = {},
                                        _a[item === null || item === void 0 ? void 0 : item.RegistrationNo] = true,
                                        _a));
                                    if ((installbaseData === null || installbaseData === void 0 ? void 0 : installbaseData.length) < 2 && mode === 'edit') {
                                        return {
                                            type: this.type,
                                            name: item === null || item === void 0 ? void 0 : item.RegistrationNo,
                                            value: true
                                        };
                                    }
                                },
                                setFormState: function (formValues, currValue, field) {
                                    if (currValue) {
                                        return {
                                            InstallBaseId: item === null || item === void 0 ? void 0 : item.InstallBaseId,
                                            VinNo: item === null || item === void 0 ? void 0 : item.VinNo,
                                            RegistrationNo: item === null || item === void 0 ? void 0 : item.RegistrationNo
                                        };
                                    }
                                }
                            }, {
                                type: FormItemTypes.Typography,
                                name: 'VehicleName',
                                label: item === null || item === void 0 ? void 0 : item.RegistrationNo,
                                children: item === null || item === void 0 ? void 0 : item.ProductName,
                                labelTypographyProps: {
                                    variant: 'h3',
                                    color: black
                                },
                                variant: 'h6',
                                color: gray,
                                columnSize: 10
                            }, {
                                type: FormItemTypes.Custom,
                                name: 'accordionData',
                                columnSize: 12,
                                element: function (props) {
                                    var _props$value, _item$EngineNo, _item$VinNo;
                                    return installbaseData.length < 2 || props !== null && props !== void 0 && (_props$value = props.value) !== null && _props$value !== void 0 && _props$value[item === null || item === void 0 ? void 0 : item.RegistrationNo] ? /*#__PURE__*/ React.createElement(MuiStack, {
                                        direction: "column",
                                        justifyContent: 'space-between',
                                        bgcolor: '#F4F7FA',
                                        borderRadius: '12px',
                                        columnGap: '5px',
                                        padding: '10px',
                                        width: '100%'
                                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                                        flexDirection: 'row',
                                        spacing: 2,
                                        justifyContent: 'space-between'
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        variant: "subtitle2",
                                        whiteSpace: 'nowrap',
                                        width: '50%',
                                        color: "secondary"
                                    }, t('Engine No'), " "), /*#__PURE__*/ React.createElement(Typography, {
                                        variant: "subtitle2",
                                        whiteSpace: 'nowrap',
                                        width: '46%'
                                    }, (_item$EngineNo = item === null || item === void 0 ? void 0 : item.EngineNo) !== null && _item$EngineNo !== void 0 ? _item$EngineNo : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
                                        flexDirection: 'row',
                                        spacing: 2,
                                        justifyContent: 'space-between'
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        variant: "subtitle2",
                                        whiteSpace: 'nowrap',
                                        width: '50%',
                                        color: "secondary"
                                    }, t('Chassis No:')), /*#__PURE__*/ React.createElement(Typography, {
                                        variant: "subtitle2",
                                        whiteSpace: 'nowrap',
                                        width: '46%'
                                    }, (_item$VinNo = item === null || item === void 0 ? void 0 : item.VinNo) !== null && _item$VinNo !== void 0 ? _item$VinNo : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
                                        flexDirection: 'row',
                                        spacing: 2,
                                        justifyContent: 'space-between'
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        variant: "subtitle2",
                                        whiteSpace: 'nowrap',
                                        width: '50%',
                                        color: "secondary"
                                    }, " ", t('Date of Sale')), /*#__PURE__*/ React.createElement(Typography, {
                                        variant: "subtitle2",
                                        whiteSpace: 'nowrap',
                                        width: '46%'
                                    }, item !== null && item !== void 0 && item.SalesInvoiceDate ? dateFormate(item === null || item === void 0 ? void 0 : item.SalesInvoiceDate) : '-'))) : null;
                                }
                            }]
                    }); })), true)
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: 'ServiceDetails',
            value: null,
            columnSize: 12,
            title: 'Service details',
            setFieldProps: function (formValues, currValue) {
                var checked = false;
                var data = [];
                installbaseData === null || installbaseData === void 0 || installbaseData.map(function (item, index) {
                    data.push(item === null || item === void 0 ? void 0 : item.RegistrationNo);
                });
                data.map(function (item) {
                    Object.keys(formValues).forEach(function (index) {
                        if (item === index) {
                            if (formValues[index]) {
                                checked = true;
                            }
                        }
                    });
                });
                return {
                    type: this.type,
                    containerProps: {
                        display: mode === 'edit' || checked ? 'inline-block' : 'none'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.NumberInput,
                    name: 'ODOMeterReading',
                    label: 'Odometer',
                    value: null,
                    columnSize: 4,
                    required: true,
                    validation: ValidationTypes.number
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ServiceAdvisorId',
                    label: 'Service Advisor',
                    displayExpr: "GivenName",
                    getListData: getServiceAdvisorByOrganizationId,
                    getOptionLabel: function (option) {
                        return (option === null || option === void 0 ? void 0 : option.GivenName) + ' ' + (option === null || option === void 0 ? void 0 : option.FamilyName);
                    },
                    valueExpr: "id",
                    value: null,
                    columnSize: 4,
                    required: true
                }]
        }];
    var PartDetails = [{
            type: FormItemTypes.Custom,
            name: 'ProprietaryWarrantyPartDetails',
            value: null,
            columnSize: 12,
            validator: function (values, state) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (r) {
                    var _Object$keys;
                    var errorField = (_Object$keys = Object.keys(ProprietaryWarrantyMandatoryFields)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (field) { return typeof r[field] !== 'number' && typeof r[field] !== 'boolean' && !r[field]; });
                    if (errorField) {
                        if (errorField === 'SettlementDate' && (r.StatusName === 'Accepted' || r.StatusName === 'Rejected')) {
                            error = {
                                id: v4(),
                                rowId: r.id,
                                field: ProprietaryWarrantyMandatoryFields[errorField],
                                message: 'This field is required',
                                value: r[errorField]
                            };
                        }
                        if (errorField && errorField !== 'SettlementDate') {
                            error = {
                                id: v4(),
                                rowId: r.id,
                                field: ProprietaryWarrantyMandatoryFields[errorField],
                                message: 'This field is required',
                                value: r[errorField]
                            };
                        }
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: ProprietaryWarrantyMandatoryFields[errorField],
                            message: 'This field is required',
                            value: r[errorField]
                        };
                    }
                    return Boolean(errorField);
                });
                return error;
            },
            element: IS_MOBILE ? WarrantyTabMobView : ProprietaryWarrantyDetails
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: General
        }, {
            id: '1',
            label: 'Warranty details',
            elements: PartDetails
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: 'back-icon',
                    id: 'back-icon',
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    }),
                    onClick: function () {
                        dispatch(setReducerState({
                            key: ProprietaryWarrantyKeys.GetSearchByTypeResults,
                            value: null
                        }));
                        navigate('/proprietaryWarranty');
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: mode == 'edit' ? 'Proprietary warranty' : 'New proprietary warranty',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    xs: 12,
                    sm: true,
                    item: false,
                    justifyContent: {
                        xs: 'space-between',
                        sm: 'flex-end'
                    },
                    spacing: 0,
                    p: {
                        xs: 2,
                        sm: 0
                    },
                    alignItems: 'center',
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: this.type,
                            display: mode === "add" ? 'none' : 'flex'
                        };
                    },
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentNumber',
                            label: 'DOC NO:',
                            children: (_getData$Code = getData === null || getData === void 0 ? void 0 : getData.Code) !== null && _getData$Code !== void 0 ? _getData$Code : '-',
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            width: {
                                xs: '70%',
                                md: '100%'
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedOn',
                            label: 'DOC DATE: ',
                            valueGetter: function (formValues, field) {
                                return getData !== null && getData !== void 0 && getData.CreatedOn ? dateFormate(dayjs(getData === null || getData === void 0 ? void 0 : getData.CreatedOn)) : '-';
                            },
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "search",
            label: "",
            value: null,
            columnSize: 12,
            p: 2,
            justifyContent: 'flex-start',
            bgcolor: lightGray,
            borderBottom: "1px solid ".concat(faintGray),
            borderTop: "1px solid ".concat(faintGray),
            setFieldProps: function (formValues, currValue) {
                var checked = false;
                var data = [];
                installbaseData.map(function (item, index) {
                    data.push(item === null || item === void 0 ? void 0 : item.RegistrationNo);
                });
                data.map(function (item) {
                    Object.keys(formValues).forEach(function (index) {
                        if (item === index) {
                            if (formValues[index]) {
                                checked = true;
                            }
                        }
                    });
                });
                return {
                    type: this.type,
                    display: mode === 'edit' || checked ? 'none' : 'flex'
                };
            },
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "searchOption",
                    size: 'small',
                    value: (_crud$ProprietaryWarr8 = (_crud$ProprietaryWarr9 = crud[ProprietaryWarrantyKeys.SearchByTypeList]) === null || _crud$ProprietaryWarr9 === void 0 || (_crud$ProprietaryWarr9 = _crud$ProprietaryWarr9[0]) === null || _crud$ProprietaryWarr9 === void 0 ? void 0 : _crud$ProprietaryWarr9.Value) !== null && _crud$ProprietaryWarr8 !== void 0 ? _crud$ProprietaryWarr8 : null,
                    children: (_crud$ProprietaryWarr10 = crud[ProprietaryWarrantyKeys.SearchByTypeList]) === null || _crud$ProprietaryWarr10 === void 0 ? void 0 : _crud$ProprietaryWarr10.map(function (item, index) { /*#__PURE__*/ return React.createElement(MenuItem, {
                        key: index,
                        value: item === null || item === void 0 ? void 0 : item.Value
                    }, item.DisplayName); }),
                    select: true,
                    labelTypographyProps: {
                        variant: "subtitle2"
                    },
                    InputProps: {
                        slotProps: {
                            input: {
                                sx: {
                                    py: 0.75,
                                    lineHeight: {
                                        xs: 'inherit',
                                        sm: 1.8
                                    }
                                }
                            }
                        }
                    },
                    sx: {
                        '& fieldset': {
                            borderTopRightRadius: 0,
                            borderBottomRightRadius: 0,
                            borderRight: 'none'
                        }
                    },
                    columnSize: 1.2,
                    xs: 4,
                    md: 1.2
                }, {
                    type: FormItemTypes.TextInput,
                    name: "InstallBaseID",
                    label: "",
                    placeholder: 'Enter text',
                    value: null,
                    columnSize: 4,
                    xs: 8,
                    sm: 8,
                    md: 6,
                    labelTypographyProps: {
                        variant: "subtitle2",
                        color: "transparent"
                    },
                    sx: {
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0,
                            borderLeft: 'none'
                        }
                    },
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        var _customerData$data, _customerData$data2, request_1, customerData_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!currValue) {
                                        dispatch(resetState(ProprietaryWarrantyResetKeys));
                                        dispatch(setReducerState({
                                            key: ProprietaryWarrantyKeys.GetSearchByTypeResults,
                                            value: null
                                        }));
                                    }
                                    if (!currValue) return [3 /*break*/, 2];
                                    request_1 = {
                                        Value: currValue,
                                        Key: formValues.searchOption
                                    };
                                    return [4 /*yield*/, getSearchByValueAPICall({
                                            request: request_1
                                        })];
                                case 1:
                                    customerData_1 = _a.sent();
                                    return [2 /*return*/, {
                                            CustomerId: customerData_1 === null || customerData_1 === void 0 || (_customerData$data = customerData_1.data) === null || _customerData$data === void 0 || (_customerData$data = _customerData$data.Customer) === null || _customerData$data === void 0 ? void 0 : _customerData$data.CustomerId,
                                            PersonId: customerData_1 === null || customerData_1 === void 0 || (_customerData$data2 = customerData_1.data) === null || _customerData$data2 === void 0 || (_customerData$data2 = _customerData$data2.Customer) === null || _customerData$data2 === void 0 ? void 0 : _customerData$data2.PersonId
                                        }];
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.Typography,
                    name: "",
                    columnSize: 12,
                    label: 'Search customer by name, mobile no, email ID, vehicle registration no.',
                    labelTypographyProps: {
                        variant: 'h6'
                    }
                }],
            spacing: 0
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                var checked = false;
                var data = [];
                installbaseData === null || installbaseData === void 0 || installbaseData.map(function (item, index) {
                    data.push(item === null || item === void 0 ? void 0 : item.RegistrationNo);
                });
                data.map(function (item) {
                    Object.keys(formValues).forEach(function (index) {
                        if (item === index) {
                            if (formValues[index]) {
                                checked = true;
                            }
                        }
                    });
                });
                return {
                    type: this.type,
                    display: mode === 'edit' || checked ? {
                        xs: 'none',
                        sm: 'flex'
                    } : 'none'
                };
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'quick-links',
                    children: 'Quick Links',
                    columnSize: 0,
                    variant: 'text',
                    startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                    sx: {
                        background: 'none'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'DownloadIcon',
                    children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                    columnSize: 0,
                    color: 'secondary',
                    variant: 'outlined'
                }, {
                    type: FormItemTypes.Button,
                    name: 'ShareIcon',
                    children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: 'PrintIcon',
                    children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 0,
                    height: '100%',
                    width: '1px',
                    bgcolor: 'rgba(0,0,0,0.1)',
                    mx: 1
                }, {
                    type: FormItemTypes.Button,
                    name: 'AddNewWarranty',
                    children: 'Add New Warranty',
                    columnSize: 0,
                    variant: 'text',
                    sx: {
                        background: 'none'
                    },
                    onClick: function (event, formValues) {
                        if (formValues) {
                            Object.keys(formValues).forEach(function (index) {
                                formValues[index] = null;
                            });
                        }
                        dispatch(resetState(ProprietaryWarrantyResetKeys));
                        dispatch(setReducerState({
                            key: ProprietaryWarrantyKeys.GetSearchByTypeResults,
                            value: null
                        }));
                        navigate('../proprietaryWarranty/createProprietaryWarranty?mode=add');
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'Discard',
                    children: 'Discard',
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: 'Save',
                    children: 'Save',
                    id: 'save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }]
        }, {
            type: FormItemTypes.Custom,
            name: '',
            element: function (props) { /*#__PURE__*/ return React.createElement(NoDocumentFound, {
                title: 'Scan vehicle number plate!',
                paragraph: 'No New proprietary warranty created yet, Please create new warranty.'
            }); },
            containerProps: {
                display: mode === 'edit' ? 'none' : !data ? {
                    md: 'none',
                    xs: 'flex',
                    sm: 'flex'
                } : 'none'
            },
            columnSize: 12
        }, {
            type: FormItemTypes.Tabs,
            name: 'Stepper',
            label: '',
            value: null,
            tabs: tabs,
            valueExpr: 'id',
            displayExpr: 'label',
            columnSize: 12,
            containerProps: {
                mx: 2,
                display: mode === 'edit' || data ? 'inline-block' : 'none'
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState(ProprietaryWarrantyApiKeys) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        getFormAPI: proprietaryWarrantyGetAPICall,
        getKey: ProprietaryWarrantyKeys.Get,
        getRequest: {
            id: id
        },
        createFormAPI: proprietaryWarrantyCreateAPICall,
        createKey: ProprietaryWarrantyKeys.Create,
        createRequest: request,
        updateFormAPI: proprietaryWarrantyCreateAPICall,
        updateKey: ProprietaryWarrantyKeys.Update,
        onClose: function () {
            dispatch(resetState(ProprietaryWarrantyResetKeys));
            navigate('/proprietaryWarranty');
        }
    }), /*#__PURE__*/ React.createElement(EditCustomerInfo, {
        parentDocumentName: EParentModuleName.ProprietaryWarranty,
        open: editCustomer,
        onUpdateClose: function () {
            setEditCustomer(function (prev) { return !prev; });
        },
        onClose: function () {
            setEditCustomer(function (eve) { return !eve; });
        },
        data: customerData,
        isDisabled: false,
        vehicleDetails: installbaseData
    }));
};
